import React from 'react';

const SettingsIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.963"
    height="24.963"
    viewBox="0 0 24.963 24.963"
  >
    <path
      fill="#818e94"
      d="M14.755,18.85a4.37,4.37,0,1,1,4.491-4.368,4.431,4.431,0,0,1-4.491,4.368m9.534-3.158a9.437,9.437,0,0,0,.09-1.211,10.386,10.386,0,0,0-.09-1.248L27,11.2a.618.618,0,0,0,.154-.8L24.584,6.081a.639.639,0,0,0-.783-.275l-3.2,1.248a9.367,9.367,0,0,0-2.169-1.223l-.475-3.308A.644.644,0,0,0,17.321,2H12.188a.644.644,0,0,0-.642.524l-.475,3.308A9.367,9.367,0,0,0,8.9,7.055l-3.2-1.248a.639.639,0,0,0-.783.275L2.36,10.4a.6.6,0,0,0,.154.8l2.707,2.034a10.386,10.386,0,0,0-.09,1.248,9.437,9.437,0,0,0,.09,1.211L2.514,17.764a.6.6,0,0,0-.154.8l2.566,4.319a.654.654,0,0,0,.783.275L8.9,21.9a8.972,8.972,0,0,0,2.169,1.236l.475,3.308a.644.644,0,0,0,.642.524h5.133a.644.644,0,0,0,.642-.524l.475-3.308A9.406,9.406,0,0,0,20.606,21.9l3.2,1.261a.654.654,0,0,0,.783-.275l2.566-4.319a.618.618,0,0,0-.154-.8Z"
      transform="translate(-2.271 -2)"
    />
  </svg>
);

export default SettingsIcon;
